import LegalLayout from "./LegalLayout";
import Footer from "../components/Footer";
import Navigation from "../components/Navigation";

export default function Impressum() {
  return (
    <>
      <Navigation />
      <LegalLayout
        title="Impressum"
        subtitle="Angaben gemäß § 5 DDG"
        testid="impressum-page"
      >
        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            Diensteanbieter
          </h2>
          <p>
            H. Dogan &amp; N. Noury<br />
            Hair &amp; Beauty Nava<br />
            Hainer Weg 146<br />
            60599 Frankfurt am Main<br />
            Deutschland
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            Kontakt
          </h2>
          <p>
            Telefon: <a href="tel:+4915759436804" className="text-white hover:text-[#D4AF37]">+49 1575 9436804</a><br />
            E-Mail: <a href="mailto:hairbeautynava@gmail.com" className="text-white hover:text-[#D4AF37]">hairbeautynava@gmail.com</a>
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
          </h2>
          <p>
            H. Dogan &amp; N. Noury<br />
            Hainer Weg 146, 60599 Frankfurt am Main
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            EU-Streitschlichtung
          </h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) bereit:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-[#D4AF37] underline"
            >
              https://ec.europa.eu/consumers/odr/
            </a>
            <br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            Verbraucherstreitbeilegung / Universalschlichtungsstelle
          </h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            Haftung für Inhalte
          </h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte
            auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
            §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
            überwachen oder nach Umständen zu forschen, die auf eine
            rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung
            oder Sperrung der Nutzung von Informationen nach den allgemeinen
            Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
            jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
            Rechtsverletzung möglich.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            Haftung für Links
          </h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            Urheberrecht
          </h2>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem deutschen Urheberrecht. Die
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
            schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </section>

        <p className="text-white/40 text-xs pt-8 border-t border-white/10">
          Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
        </p>
      </LegalLayout>
      <Footer />
    </>
  );
}
